import { EnrichedEventData } from './GA/types'
import Tracker from './TrackerNew'

/** Helper function to merge previous enrichedEventData with new enrichedEventData ready to be set on the Tracker itself. */
export const expandEnrichedEventData = (
  tracker: Tracker,
  newData: Partial<EnrichedEventData>
) => {
  if (tracker.isTrackingEnabled) {
    const prevData = tracker.enrichedEventData
    tracker.setEnrichedEventData({
      ...prevData,
      ...newData
    })
  }
}
